import { buildClaimsFilterParams } from 'utils/utils';
import authFetch, { checkForUnauthorizedResponse } from '../../utils/axios';

import { thunkLoadingParams } from 'feature/progressIndicator/progressIndicatorSlice';
import { IClaimDownload } from 'types/Claims';
import { ThunkApiType } from 'types/storeTypes';
import { NOTIFICATIONS_EXPIRY_DAYS } from 'utils/constants';
import { exportListToExcel } from 'utils/download';

export const getClaimsByProviderThunk = async (
	arg: thunkLoadingParams & { limit?: string },
	thunkAPI: ThunkApiType,
) => {
	let getClaimsURL = `/claim`;

	const { page } = thunkAPI.getState().claims;
	const claimsSearchValues = thunkAPI.getState().form;
	const {
		profile: { providerId },
	} = thunkAPI.getState().user;

	const { sortingFields, sortingDirections } = thunkAPI.getState().form;

	const limitParam = arg?.limit ? `&limit=${arg.limit}` : '';
	const { queryParams } = buildClaimsFilterParams(claimsSearchValues);
	if (providerId) {
		getClaimsURL =
			getClaimsURL +
			`?page=${page}${limitParam}&providerId=${providerId}&sortingFields=${sortingFields}&sortingDirections=${sortingDirections}${
				queryParams || ''
			}`;
		try {
			const response = await authFetch.get(getClaimsURL);
			return response.data;
		} catch (error: ThunkApiType) {
			return checkForUnauthorizedResponse(error, thunkAPI);
		}
	}
};

export const downloadClaimsThunk = async (
	{ Uuid, type }: IClaimDownload,
	thunkAPI: ThunkApiType,
) => {
	let getDownloadClaimIdURL = '/claim/downloadClaimDetail';
	let getDownloadClaimsListURL = `/claim/downloadClaimList`;

	if (!!Uuid) {
		getDownloadClaimIdURL = getDownloadClaimIdURL + `?claimUuid=${Uuid}`;
		try {
			const response = await authFetch.get(getDownloadClaimIdURL, {
				responseType: 'blob',
			});
			exportListToExcel(response.data, 'Claim', type);
			return true;
		} catch (error: ThunkApiType) {
			return checkForUnauthorizedResponse(error, thunkAPI);
		}
	} else {
		const {
			claimIds,
			claimExcludeIds,
			downloadAll,
			claimUuids,
			claimExcludeUuids,
		} = thunkAPI.getState().claims;

		const { sortingFields, sortingDirections } = thunkAPI.getState().form;
		const { body: filterBody } = buildClaimsFilterParams(
			thunkAPI.getState().form,
		);

		const sortField = sortingFields || 'serviceDate,externalClaimId';
		const sortDirection = sortingDirections || 'DESC,DESC';

		const {
			profile: { providerId },
		} = thunkAPI.getState().user;

		const values = {
			...filterBody,
			format: type,
			claimIds: downloadAll ? [] : claimIds,
			claimUuids: downloadAll ? [] : claimUuids,
			claimExcludeIds: claimExcludeIds,
			claimExcludeUuids: claimExcludeUuids,
			providerId: providerId,
			sortingFields: sortField,
			sortingDirections: sortDirection,
		};
		try {
			const response = await authFetch.post(getDownloadClaimsListURL, values, {
				responseType: 'blob',
			});
			exportListToExcel(response.data, 'Claims', type);
			return true;
		} catch (error: ThunkApiType) {
			return checkForUnauthorizedResponse(error, thunkAPI);
		}
	}
};

export const getClaimsNotificationsThunk = async (
	arg: thunkLoadingParams & { limit?: string; list?: boolean },
	thunkAPI: ThunkApiType,
) => {
	let getClaimsNotificationsURL = `/claim/notifications/${NOTIFICATIONS_EXPIRY_DAYS}`;

	const { page } = thunkAPI.getState().claims;
	const claimsSearchValues = thunkAPI.getState().form;
	const {
		profile: { providerId },
	} = thunkAPI.getState().user;

	const { sortingFields, sortingDirections } = thunkAPI.getState().form;

	const limitParam = arg?.limit ? `&limit=${arg.limit}` : '';
	const { queryParams } = buildClaimsFilterParams(claimsSearchValues);

	if (providerId) {
		if (arg.list) {
			getClaimsNotificationsURL =
				getClaimsNotificationsURL +
				`?page=${page}${limitParam}&providerId=${providerId}&sortingFields=${sortingFields}&sortingDirections=${sortingDirections}${
					queryParams || ''
				}`;
		} else {
			getClaimsNotificationsURL =
				getClaimsNotificationsURL +
				`?page=${page}${limitParam}&providerId=${providerId}`;
		}

		try {
			const response = await authFetch.get(getClaimsNotificationsURL);
			return response.data;
		} catch (error: ThunkApiType) {
			return checkForUnauthorizedResponse(error, thunkAPI);
		}
	}
};

export const getClaimsNotificationsStatusesThunk = async (
	arg: thunkLoadingParams,
	thunkAPI: ThunkApiType,
) => {
	let getClaimsNotificationsStatusesURL = '/claim/notifications/status';

	try {
		const response = await authFetch.get(getClaimsNotificationsStatusesURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};
